import React from 'react';
import { useEffect, useState, forwardRef } from 'react';

interface LocationFinderProps {
  messages?: any;
  timeBetweenMessages?: number;
  timeLastMessage?: number;
}

export const LocationFinder = forwardRef<SVGSVGElement, LocationFinderProps>(
  ({ messages, timeBetweenMessages = 2000, timeLastMessage = 4000 }, ref) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
      setCurrentIndex(0);
      setOpacity(1);
    }, [messages]);

    useEffect(() => {
      // Don't cycle if we're on the last message
      if (currentIndex === messages.length - 1) {
        return;
      }

      // Determine duration based on current message
      const isPenultimateMessage = currentIndex === messages.length - 2;
      const duration = isPenultimateMessage
        ? timeLastMessage
        : Math.random() * 1000 + timeBetweenMessages; // Random between 2000-3000ms

      // Start fade out after showing the message
      const fadeOutTimer = setTimeout(() => {
        setOpacity(0);
      }, duration - 300); // Start fading 300ms before transition

      // Change message
      const changeTimer = setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
        setOpacity(1);
      }, duration);

      return () => {
        clearTimeout(fadeOutTimer);
        clearTimeout(changeTimer);
      };
    }, [currentIndex, messages]);

    return (
      <svg
        ref={ref}
        width='393'
        height='60'
        viewBox='0 0 393 60'
        xmlns='http://www.w3.org/2000/svg'
        style={{ background: 'white' }}
      >
        <defs>
          <style type='text/css'>
            {`          
            
            @keyframes sonar-pulse {
              0% {
                r: 10px;
                opacity: 0.4;
              }
              50% {
                opacity: 0.2;
              }
              100% {
                r: 30px;
                opacity: 0;
              }
            }

            .sonar-ring-1 {
              animation: sonar-pulse 2s ease-out infinite;
            }
            
            .sonar-ring-2 {
              animation: sonar-pulse 2s ease-out infinite 0.66s;
            }
            
            .sonar-ring-3 {
              animation: sonar-pulse 2s ease-out infinite 1.32s;
            }
          `}
          </style>
        </defs>

        {/* Sonar rings */}
        <circle className='sonar-ring-1' cx='30' cy='30' r='10' fill='#DA291C' />
        <circle className='sonar-ring-2' cx='30' cy='30' r='10' fill='#DA291C' />
        <circle className='sonar-ring-3' cx='30' cy='30' r='10' fill='#DA291C' />

        {/* Main solid dot */}
        <circle cx='30' cy='30' r='10' fill='#DA291C' />

        {/* Text label with fade transition */}
        <text
          x='75'
          y='38'
          fill='#3D3935'
          fontFamily='Figtree'
          fontWeight='bold'
          fontSize='16'
          style={{
            opacity: opacity,
            transition: 'opacity 0.3s ease-in-out'
          }}
        >
          {messages[currentIndex]}
        </text>
      </svg>
    );
  }
);
